<div *ngIf="emailsAllowed && !loading" class="button-container email-alerts-setup-button-container" (click)="onClick()">
    <button mat-flat-button color="warn" *ngIf="!alertsEnabled"><span class="button-text">Setup email alerts&nbsp;&nbsp;</span><mat-icon>email</mat-icon></button>
    <button mat-flat-button *ngIf="alertsEnabled" class="normal-button"><span class="button-text">Manage email alerts&nbsp;&nbsp;</span><mat-icon>email</mat-icon></button>
</div>
